import { Card, CardContent, CardHeader } from '@mui/material';
import { Title, useGetList } from 'react-admin';
import { ApiMonitor } from './components/ApiMonitor';

export const Dashboard = () => {
  const { data: coins, total: totalCoins, isLoading: coinsLoading } = useGetList('coins', {
    pagination: { page: 1, perPage: 1 },
  });

  const { data: categories, total: totalCategories, isLoading: categoriesLoading } = useGetList('categories', {
    pagination: { page: 1, perPage: 1 },
  });

  const { data: platforms, total: totalPlatforms, isLoading: platformsLoading } = useGetList('platforms', {
    pagination: { page: 1, perPage: 1 },
  });

  const { data: chains, total: totalChains, isLoading: chainsLoading } = useGetList('chains', {
    pagination: { page: 1, perPage: 1 },
  });

  return (
    <div>
      <Title title="Markets Admin Dashboard" />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem', padding: '1rem' }}>
        <Card>
          <CardHeader title="Total Coins" />
          <CardContent>
            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#1976d2' }}>
              {coinsLoading ? '...' : totalCoins || 0}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader title="Total Categories" />
          <CardContent>
            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#2e7d32' }}>
              {categoriesLoading ? '...' : totalCategories || 0}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader title="Total Platforms" />
          <CardContent>
            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#ed6c02' }}>
              {platformsLoading ? '...' : totalPlatforms || 0}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader title="Total Chains" />
          <CardContent>
            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#9c27b0' }}>
              {chainsLoading ? '...' : totalChains || 0}
            </div>
          </CardContent>
        </Card>
      </div>

      <div style={{ padding: '1rem' }}>
        <ApiMonitor />
      </div>

      <div style={{ padding: '1rem' }}>
        <Card>
          <CardHeader title="Welcome to Markets Admin" />
          <CardContent>
            <p>
              Manage your cryptocurrency markets data including coins, categories, platforms, chains,
              treasuries, funds, and more.
            </p>
            <p style={{ marginTop: '1rem' }}>
              <strong>Quick Links:</strong>
            </p>
            <ul>
              <li>Coins - Manage cryptocurrency listings</li>
              <li>Categories - Organize coins into categories</li>
              <li>Platforms - Manage trading platforms</li>
              <li>Chains - Blockchain networks</li>
              <li>Treasuries - Corporate crypto holdings</li>
              <li>Funds - Investment funds data</li>
            </ul>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
